import { strategyReport } from '@/utils/strategyReport';

type Tone = 'default' | 'profit' | 'loss';

interface Figure {
  label: string;
  value: string;
  tone: Tone;
}

const toneClass: Record<Tone, string> = {
  default: 'text-foreground-900',
  profit: 'text-profit-600',
  loss: 'text-loss-500',
};

const figures: Figure[] = [
  { label: 'Currency', value: strategyReport.currency, tone: 'default' },
  {
    label: 'Gain',
    value: strategyReport.gainText,
    tone: strategyReport.gainPositive ? 'profit' : 'loss',
  },
  { label: 'Trading Activity', value: strategyReport.tradingActivityText, tone: 'default' },
  { label: 'Deposits', value: strategyReport.depositsText, tone: 'default' },
  { label: 'Withdrawals', value: strategyReport.withdrawalsText, tone: 'default' },
  { label: 'Dividends', value: strategyReport.dividendsText, tone: 'default' },
  { label: 'Corrections', value: strategyReport.correctionsText, tone: 'default' },
  { label: 'Credit', value: strategyReport.creditText, tone: 'default' },
];

// The top account strip of the MetaTrader report — value over label, with
// hairline separators that stay correct as the grid reflows at each breakpoint.
function FigureStrip() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8">
      {figures.map((figure) => (
        <div
          key={figure.label}
          className="border-b border-r border-background-200 px-4 py-4 md:px-5"
        >
          <p
            className={`font-data text-[15px] font-semibold whitespace-nowrap ${toneClass[figure.tone]}`}
          >
            {figure.value}
          </p>
          <p className="mt-1.5 text-[11px] text-foreground-500">{figure.label}</p>
        </div>
      ))}
    </div>
  );
}

export default FigureStrip;